import { CoreManifest } from '../../../manifest';

import type { CredentialParams, CredentialContext, SocketCredentialsStrategy } from './types';

export class CoreCredentialsStrategy implements SocketCredentialsStrategy {
  /**
   * Sets credentials with validation
   */
  setCredentials(params: CredentialParams, context: CredentialContext): void {
    const { url, jsessionId, tableId, launchSource } = params;

    // Set base URL and core parameters
    this.setBaseUrl(url, context);
    this.setSessionParams(jsessionId, tableId, context);

    // Set optional parameters
    if (launchSource) {
      this.setOptionalParam('launchSource', launchSource, context);
    }

    if (CoreManifest.gameServerVersion) {
      this.setOptionalParam('version', CoreManifest.gameServerVersion, context);
    }
  }

  // Sets the base URL for the WebSocket connection
  protected setBaseUrl(url: string, context: CredentialContext): void {
    if (url) context.baseUrl = url;
  }

  // Sets required session parameters
  protected setSessionParams(jsessionId: string, tableId: string, context: CredentialContext): void {
    if (jsessionId) context.searchParams.set('JSESSIONID', jsessionId);
    if (tableId) context.searchParams.set('tableId', tableId);
    context.searchParams.set('type', 'json');
  }

  // Sets an optional parameter
  protected setOptionalParam(key: string, value: string, context: CredentialContext): void {
    if (key && value) {
      context.searchParams.set(key, value);
    }
  }
}
